import { render, staticRenderFns } from "./CampoSwitch.vue?vue&type=template&id=0453ce66&scoped=true"
import script from "./CampoSwitch.vue?vue&type=script&lang=js"
export * from "./CampoSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0453ce66",
  null
  
)

export default component.exports